export enum CompanyTypeEnum {
    BMR_INDUSTRIES_PRIVATE_LIMITED = "BMR INDUSTRIES PRIVATE LIMITED",
    BMR_EXPORTS_AP = "BMR EXPORTS-AP",
    BMR_EXPORTS_ODISHA = "BMR EXPORTS-ODISHA",

}
export enum DisplayNameEnum {
    BMR_INDUSTRIES_PRIVATE_LIMITED = "BMR INDUSTRIES PRIVATE LIMITED",
    BMR_EXPORTS = "BMR EXPORTS",

}